import { useState, useEffect, useRef } from "@wordpress/element";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

export function Component({ images }) {
  const [pause, setPause] = useState(false);
  const timer = useRef(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [mounted, setMounted] = useState(false);

  const hasSlider = images.length > 1;
  const SLIDE_INTERVAL = 15;

  const [sliderRef, slider] = !hasSlider
    ? [useRef(), null]
    : useKeenSlider({
        loop: true,
        duration: 500,
        mounted: () => {
          setMounted(true);
        },
        slideChanged: (slide) => {
          setCurrentSlide(slide.details().relativeSlide);
        },
        dragStart: () => {
          setPause(true);
        },
        dragEnd: () => {
          setPause(false);
        },
      });

  useEffect(() => {
    hasSlider && sliderRef.current.addEventListener("mouseover", () => {
      setPause(true);
    });
    hasSlider && sliderRef.current.addEventListener("mouseout", () => {
      setPause(false);
    });
  }, [sliderRef]);

  useEffect(() => {
    if (!hasSlider) { 
      return;
    }

    timer.current = setInterval(() => {
      if (!pause && slider) {
        slider.next();
      }
    }, SLIDE_INTERVAL * 1000);

    return () => {
      clearInterval(timer.current);
    };
  }, [pause, slider]);

  return (
    <>
      <div
        ref={sliderRef}
        className={["keen-slider h-full direction-ltr", !mounted && hasSlider && "opacity-0"]
          .filter(Boolean)
          .join(" ")}
      >
        {images &&
          images.map((img, index) => {
            return (
              <div key={index} className="keen-slider__slide">
                <img
                  className="h-full w-full object-cover"
                  src={img.url}
                  alt={img.alt}
                />
              </div>
            );
          })}
      </div>
      {slider && slider.details().size > 1 && (
        <div className="dots absolute w-full flex justify-center top-100% mt-6 lg:mt-0 mb-3 lg:top-auto lg:bottom-0">
          {[...Array(slider.details().size).keys()].map((index) => {
            return (
              <button
                key={index}
                onClick={() => {
                  slider.moveToSlideRelative(index);
                }}
                className={[
                  "dot w-2.5 h-2.5 lg:w-3 lg:h-3 lg:shadow-xl rounded-full mx-2",
                  currentSlide === index
                    ? "bg-blue-900 active"
                    : "bg-gray-300 lg:bg-white",
                ]
                  .filter(Boolean)
                  .join(" ")}
              />
            );
          })}
        </div>
      )}
    </>
  );
}

export const selector = ".career-items-slider";
